import { AxiosResponse } from "axios";

import {
  ISnomedMedication,
  ISnomedMedicationEditionSummary,
  ISnomedMedicationsFilters,
} from "../../@types/admin/AdminMedication";
import { IPaginatedResponse } from "../../@types/PaginatedResponse";
import { api } from "../api";

/**
 * Medications admin page (EN-5209): read-only browser over the SNOMED CT
 * medication reference data the app's medication search reads from.
 *
 * Distinct from `services/medicationService.ts`, which is a patient's own
 * medication list under `/Portal/Medications`.
 *
 * Server-paginated and server-sorted: the table holds ~30k rows across the
 * seeded editions, so nothing is held client-side.
 */
export const snomedMedicationsService = {
  async getMedications(
    filters: ISnomedMedicationsFilters
  ): Promise<AxiosResponse<IPaginatedResponse<ISnomedMedication[]>>> {
    return api.get<IPaginatedResponse<ISnomedMedication[]>>(
      "/Retool/Medications",
      {
        params: {
          page: filters.page,
          pageSize: filters.pageSize,
          // Undefined values are dropped by axios, which keeps the URL (and
          // the query key) honest about what is actually being filtered on.
          search: filters.search || undefined,
          edition: filters.edition || undefined,
          // The API takes an array (any-of); the page filters on one tag at a
          // time, and a single value binds to the array without the `[]`
          // suffix axios would add to a JS array.
          semanticTags: filters.semanticTag || undefined,
          active: filters.active,
          sortBy: filters.sortBy,
          sortDescending: filters.sortDescending,
        },
      }
    );
  },

  /** Per-edition census: total / active / retired and active per semantic tag. */
  async getSummary(): Promise<
    AxiosResponse<ISnomedMedicationEditionSummary[]>
  > {
    return api.get<ISnomedMedicationEditionSummary[]>(
      "/Retool/Medications/Summary"
    );
  },
};
